$(() => {
  if ($('.js-preview-iframe').length === 0) {
    return;
  }

  function preview($form) {
    // ここでやってることをざっくり言うと、
    // * 保存用のformをコピーして向き先をプレビューURLに変える
    // * targetをiframeに向けてPOSTの結果がiframeに突っ込まれるようにする
    // * DOM上に存在しないformはsubmitできないので不可視化してappendしてsubmitしたらすぐ消す
    const $f = $form.clone();

    // selectの値はcloneだと引き継がれない
    $form.find('select').each((i, s) => {
      $($f.find('select')[i]).find('option:selected').val($(s).find('option:selected').val());
    });

    $f.find('[name=_method]').remove();
    $f.prop('action', $f.data('preview-url'));
    $f.prop('target', 'preview-iframe');
    $f.hide();

    $('body').append($f);
    $f.submit();
    $f.remove();
  }

  $('a.js-preview-trigger').on('click', () => preview($('.js-preview-form')));
});
